// © Microsoft Corporation. All rights reserved.

/**
 * Constants that are used throughout the library
 */
export namespace ConnectorConstants {
    /**
     * The key within a state JSON document used to store a connectors individual state
     */
    export const connectorStateKey = "_@STATE@_";

    export const renderAction = "@@connector-view/RENDER";

    export const dataConnectorMergeInitAction = "@@data-connector/MERGE-INIT";
}